<template>
  <div>
    <hooper :settings="hooperSettings">
      <slide v-for="(brand, i) in brandList" :key="i">
        <LazyImage :src="brand.src" alt="brand" class="brand-logo" />
      </slide>
    </hooper>
  </div>
</template>

<script>
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";
import LazyImage from "./LazyImage";

export default {
  components: {
    Hooper,
    Slide,
    LazyImage,
  },
  data() {
    return {
      brandList: [
        {
          src: require("../assets/img/partners/1.png"),
        },
        {
          src: require("../assets/img/partners/2.png"),
        },
        {
          src: require("../assets/img/partners/3.png"),
        },
        {
          src: require("../assets/img/partners/4.png"),
        },
        {
          src: require("../assets/img/partners/5.png"),
        },
        {
          src: require("../assets/img/partners/6.png"),
        },
        {
          src: require("../assets/img/partners/7.png"),
        },
        {
          src: require("../assets/img/partners/8.png"),
        },
        {
          src: require("../assets/img/partners/9.png"),
        },
        {
          src: require("../assets/img/partners/10.png"),
        },
        {
          src: require("../assets/img/partners/11.png"),
        },
      ],
      hooperSettings: {
        infiniteScroll: true,
        wheelControl: false,
        autoPlay: true,
        transition: 200,
        playSpeed: 1500,
        breakpoints: {
          1200: {
            itemsToShow: 4,
          },
          576: {
            itemsToShow: 3,
          },
          280: {
            itemsToShow: 2,
          },
        },
      },
    };
  },
};
</script>

<style lang="scss">
.hooper {
  height: auto;
  padding: 20px 0;

  .brand-logo {
    max-width: 120px;
    height: auto;
    margin: 0 auto;
    filter: grayscale(1);
    opacity: 0.6;
    transition: all 0.3s ease;

    &:hover {
      filter: grayscale(0);
      opacity: 1;
      transform: scale(1.05);
    }
  }
}

.dark {
  .hooper {
    .brand-logo {
      opacity: 0.5;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
